<div class="container px-4 py-5 my-5 text-center bg-white rounded-4">
  <h1 class="display-5 fw-bold text-body-emphasis">Dorpelbestellen.nl</h1><br>
  <h4> Bedankt voor uw bestelling wij gaan voor u aan de slag! </h4>
  <div class="gif-wrapper">
    <img src="/assets/done.gif">
  </div>
  <div class="col-lg-6 text-center mx-auto">
    <br/>
    <span>Wij sturen u binnen enkele minuten per e-mail de orderbevestiging.</span>
    <br/><br/>
    <span>Uw ordernummer: {{orderNo}}</span>
    <br/>
    <span>Uw portaalcode: {{requestId}}</span>
    <br/>
    <button type="button" class="action-button done-button btn btn-primary btn-lg px-4 gap-3 border-0 rounded-0"
      (click)="onButtonClicked()">
      <b>Naar dorpelportaal</b>
    </button>
  </div>
</div>